import { ItemCell, Label, NoteIcon, OrderContainer, OrderItem, StyledLink } from './styledComponents';

import { FormattedMessage } from 'react-intl';
import Money from '../Money/Money';
import Notes from './Notes.svg';
import { Popover } from 'antd';
import PriceByStatus from './PriceByStatus';
import React, { FC } from 'react';
import messages from 'containers/OrdersPage/messages';
import styled from 'styled-components';
import utilsMessages from 'utils/messages';
import ItemQuantity from './ItemQuantity';
import generateProductSlug from 'utils/generateProductSlug';
import { Order } from 'types/schema';
import { getUomNameLocal } from 'utils/getUomNameLocal';
import { OrderStatus } from '../../types/schema';
import calculateVAT from 'utils/calculateVAT';
interface DesktopTableProps {
  order: Order;
}

const Note = styled.p`
  color: #8c8c8c;
`;

const LegacyDesktopTable: FC<DesktopTableProps> = (props) => {
  const { order } = props;
  const lang = localStorage.getItem('lang') || 'vi';
  const isShowItemDiscountValue =
    !!order.discount && [OrderStatus.Delivering, OrderStatus.Delivered].includes(order.status);
  return (
    <OrderContainer>
      <OrderItem className="header">
        <ItemCell key="Product" fbasis={isShowItemDiscountValue ? '25%' : '30%'}>
          <FormattedMessage {...messages.product} />
        </ItemCell>
        <ItemCell key="Price" fbasis="15%">
          <FormattedMessage {...utilsMessages.priceExcludedVat} values={{break: <br />}} />
        </ItemCell>
        {isShowItemDiscountValue && (
          <ItemCell key="PriceAfterDiscount" fbasis="15%">
            <FormattedMessage {...utilsMessages.priceAfterDiscount} />
          </ItemCell>
        )}
        <ItemCell key="Quantity" fbasis="15%">
          <FormattedMessage {...utilsMessages.quantity} />
        </ItemCell>
        <ItemCell key="TotalBeforeVat" fbasis="15%">
          <FormattedMessage {...utilsMessages.totalExclVat} values={{break: <br />}} />
        </ItemCell>
        <ItemCell key="Vat" fbasis="10%">
          VAT
        </ItemCell>
        <ItemCell key="TotalAfterVat" fbasis="15%">
          <FormattedMessage {...utilsMessages.totalIncludedVat} values={{break: <br />}} />
        </ItemCell>
        {isShowItemDiscountValue && (
          <ItemCell key="TotalAfterDiscount" fbasis="15%">
            <FormattedMessage {...utilsMessages.totalAfterDiscountInclVAT} />
          </ItemCell>
        )}
        <ItemCell key="Notes" fbasis="5%" />
      </OrderItem>
      {order.items.map((item, index) => {
        const {
          product: { id, vat, uomLocal, name, supplierInternalCode },
          buyerNote,
          orderedPrice,
          price,
          orderedQuantity,
          deliveryQuantity,
          total,
          deliveredNote,
          unitPriceAfterDiscount,
          amountAfterDiscount,
          orderedPriceV2,
          priceV2,
          totalBeforeVat,
        } = item;
        return (
          <OrderItem key={id}>
            <ItemCell key="Product" fbasis={isShowItemDiscountValue ? '25%' : '30%'}>
              <StyledLink title={name} to={`/products/${generateProductSlug(name, supplierInternalCode, lang)}`}>
                {name}
              </StyledLink>
              {buyerNote && <Note>{buyerNote}</Note>}
            </ItemCell>
            <ItemCell key="Price" fbasis="15%">
              <PriceByStatus
                orderedPrice={
                  calculateVAT(
                    orderedPriceV2?.price || 0,
                    orderedPriceV2?.vat || 0,
                    !!orderedPriceV2?.vatIncluded,
                  ).beforeVat.toString() || ''
                }
                deliveredPrice={
                  calculateVAT(priceV2?.price || 0, priceV2?.vat || 0, !!priceV2?.vatIncluded).beforeVat.toString() ||
                  ''
                }
                status={order.status}
              />
            </ItemCell>
            {isShowItemDiscountValue && (
              <ItemCell key="PriceAfterDiscount" fbasis="15%">
                <Money>{Number(unitPriceAfterDiscount)}</Money>
              </ItemCell>
            )}
            <ItemCell key="Quantity" fbasis="15%">
              <ItemQuantity
                orderedQuantity={Number(orderedQuantity)}
                deliveryQuantity={Number(deliveryQuantity)}
                uom={getUomNameLocal(uomLocal || '')}
              />
            </ItemCell>
            <ItemCell key="TotalBeforeVat" fbasis="15%">
              <Money>{totalBeforeVat || 0}</Money>
            </ItemCell>
            <ItemCell key="Vat" fbasis="10%">
              {vat}%
            </ItemCell>
            <ItemCell key="Total" fbasis="15%">
              <span>
                <Money>{total || 0}</Money>
              </span>
            </ItemCell>
            {isShowItemDiscountValue && (
              <ItemCell key="TotalAfterDiscount" fbasis="15%">
                <span>
                  <Money>{Number(amountAfterDiscount) || 0}</Money>
                  <br />
                  <Label>( {vat}% VAT )</Label>
                </span>
              </ItemCell>
            )}
            <ItemCell key="Notes" fbasis="5%">
              {deliveredNote && (
                <Popover content={<pre>{deliveredNote}</pre>}>
                  <NoteIcon src={Notes} note="true" />
                </Popover>
              )}
            </ItemCell>
          </OrderItem>
        );
      })}
    </OrderContainer>
  );
};

export default LegacyDesktopTable;
